import { SchemaTypes } from '@allesauto/graphql';
import translate from '@allesauto/i18n';
import { formatPrice } from '@allesauto/utils/funcs';
import { IntlShape } from 'react-intl';

const toPercent = (percent: number) => {
  return `${percent} %`;
};

export const getFinanceDetails = (
  intl: IntlShape,
  conditions: SchemaTypes.FinanceCalculationResult | undefined
) => {
  const toPrice = (price: number) => {
    return formatPrice(intl, price, {
      withFractionDigits: true,
    });
  };

  if (!conditions) return undefined;

  let description = `${translate(
    intl,
    'ui.CHECKOUT.SIDE_BAR.VEHICLE_PRICE'
  )} ${toPrice(conditions.vehiclePrice || 0)}, `;
  description += `${translate(
    intl,
    'ui.CHECKOUT_SIDEBAR.MONTHLY_PAYMENT_TITLE'
  )} ${toPrice(conditions.monthlyInstallment || 0)}, `;
  description += `${translate(
    intl,
    'ui.CHECKOUT_SIDEBAR.DOWN_PAYMENT_TITLE'
  )} ${toPrice(conditions.downPayment || 0)}, `;
  description += `${conditions.duration ?? ''} ${translate(
    intl,
    'ui.CHECKOUT.SIDE_BAR.DURATION'
  )}, `;
  description += `${translate(
    intl,
    'ui.CHECKOUT.SIDE_BAR.ANNUAL_INTEREST'
  )} ${toPercent(conditions.effectiveInterestRate || 0)}, `;
  description += `${translate(
    intl,
    'ui.CHECKOUT.SIDE_BAR.BORROWING_RATE'
  )} ${toPercent(conditions.nominalInterestRate || 0)}, `;
  description += `${translate(
    intl,
    'ui.PDP.FOOTER.FINAL_INSTALLMENT'
  )} ${toPrice(conditions.finalInstallment || 0)}, `;
  description += `${translate(
    intl,
    'ui.CHECKOUT.SIDE_BAR.TOTAL_REPAYMENT'
  )} ${toPrice(conditions.totalRepaymentAmount || 0)}`;

  return description;
};
